import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TinyMCEEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);

  const handleEditorChange = (content, editor) => {
    onChange(content);
  };

  return (
    <Editor
      apiKey="86j72u18umgns8fh8el727r3kvowgyhu0tj9vfhyjzj8c9g7"
      onInit={(evt, editor) => editorRef.current = editor}
      value={value}
      onEditorChange={handleEditorChange}
      init={{
        height: 300,
        menubar: false,
        directionality: 'ltr',
        plugins: [
          'lists', 'link', 'charmap', 'preview', 'searchreplace', 'visualblocks',
          'code', 'fullscreen', 'insertdatetime', 'table', 'help', 'wordcount'
        ],
        toolbar: 'undo redo | blocks | ' +
          'bold italic forecolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'removeformat | link | code | fullscreen | help',
        content_style: `
          body { 
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; 
            font-size: 14px; 
            line-height: 1.4;
            direction: ltr !important;
            text-align: left !important;
            unicode-bidi: embed;
          }
          p { 
            margin: 0 0 8px 0; 
            direction: ltr !important;
            text-align: left !important;
            unicode-bidi: embed;
          }
          ul, ol { margin: 8px 0; padding-left: 20px; }
          strong { font-weight: 600; }
          * {
            direction: ltr !important;
            unicode-bidi: embed !important;
          }
        `,
        placeholder: placeholder || 'Enter your response...',
        setup: (editor) => {
          editor.on('init', () => {
            editor.getContainer().style.borderRadius = '6px';
          });
        }
      }}
    />
  );
};

export default TinyMCEEditor;